import React from 'react'
import * as Images from '../../../assets';

const AboutTheProgram = ({ titleRef, isVisible }) => {
    return (
        <>
            <div className="flex justify-center items-center px-16 py-12 bg-white max-md:px-5 max-md:py-6 max-sm:py-0" ref={titleRef}>
                <div className="mt-6 max-w-full w-[1296px] max-sm:mt-0">
                    <div className="flex justify-between gap-5 max-lg:flex-col max-md:gap-0 max-md:">
                        <div className="flex flex-col w-[50%] max-md:ml-0 max-lg:w-full">
                            <img
                                loading="lazy"
                                // src={Images.make_my_business_intro}
                                src={Images.about_the_program_tej}
                                className="grow w-full aspect-[1.49] max-md:mt-10 max-sm:mt-0 max-md:max-w-full rounded-xl"
                                style={{ boxShadow: '0 0 10px 0 rgba(255, 115, 0, 0.25)' }} // custom orange shadow
                                alt="Images"
                            />
                        </div>
                        <div className="flex flex-col justify-center ml-5 w-[40%] max-md:ml-0 max-lg:w-full max-lg:mt-5">
                            <div className="text-start flex flex-col text-lg max-md:mt-10 max-md:max-w-full">
                                <div className="text-4xl font-medium  max-md:max-w-full max-md:text-4xl">
                                    <div
                                        // className=" leading-[58px]"
                                        //className="about-us_title_animation_fade_in_right"
                                        className={`font-bold ${isVisible ? 'about-us_title_animation_fade_in_right' : ''}`}
                                    >ABOUT THE <span className='text-orange-500'>PROGRAM</span> </div>

                                </div>
                                <div className="mt-6 max-md:max-w-full blog_intro">
                                    This is no ordinary training.<br />This is a 4-day Deep Strategic & Inner Leadership Immersion, where select jewellers are taken out of the crowd and led towards Clarity, Control, Scale and Legacy.
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutTheProgram
